import { Component, Input, OnInit } from '@angular/core';
import { Store } from '@ngrx/store';
import { Activity, selectUnread } from '../store';
import * as fromActivities from '../store/activity.actions';
import { Observable } from 'rxjs';
import { tap } from 'rxjs/operators';
import { AppState } from 'src/app/store';

@Component({
    selector: 'app-activity-icon',
    templateUrl: './activity-icon.component.html',
    standalone: false
})
export class ActivityIconComponent implements OnInit {
  notifications$: Observable<Activity[]>;
  hidden = false;
  @Input() orgId: string;

  constructor(private store: Store<AppState>) {}

  ngOnInit(): void {
    this.notifications$ = this.store.select(selectUnread)?.pipe(
      tap((unread) => {
        const orgId = unread[0]?.data?.orgId;
        if (orgId === this.orgId) {
          this.store.dispatch(fromActivities.saveUnreadNotifications({ unread, orgId }));
        }
      })
    );
  }

  toggleBadgeVisibility(unread: Activity[]) {
    this.store.dispatch(fromActivities.toggleSidebar({orgId: this.orgId}));
    this.store.dispatch(fromActivities.markAsRead({ unread, isRead: true }));
  }
}
